import TofuShell from "./components/layout/TofuShell";
import Header from "./components/layout/Header";
import ChatContainer from "./components/chat/ChatContainer";
import Composer from "./components/layout/Composer";
import GlobalSafetyFooter from "./components/layout/GlobalSafetyFooter";
import { useChatSession } from "./hooks/useChatSession";

import "./App.css";

export default function TofuApp() {
  const { messages, typingMessage, sendMessage} = useChatSession();

  return (
    <TofuShell>
      <Header />
      <ChatContainer
        messages={messages}
        typingMessage={typingMessage}
      />
      <Composer onSend={sendMessage} />
      <GlobalSafetyFooter />
    </TofuShell>
  );
}